<template>
  <div>
    <div class="row-tb-head" style="margin-top: 10px">
      <span>{{ title }}</span>
      <div style="float: right">
        <el-button type="primary" @click="add">添加</el-button>
      </div>
    </div>
    <el-table ref="table" class="table-line tb-c-head" :data="saveData" border>
      <slot name="table"></slot>
      <el-table-column label="操作" fixed="right" align="center" width="80">
        <template slot-scope="{ row, $index }">
          <el-button
            v-if="$permission.canWrite()"
            type="text"
            @click="del(row, $index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "wjSubTable",
  props: {
    title: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default: () => [],
    },
    column: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.saveData = this.data;
  },
  watch: {
    data(value) {
      console.log(this.data);
      this.saveData = value;
    },
  },
  data() {
    return {
      tableDel: [],
      saveData: [],
    };
  },
  methods: {
    del(row, index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.T !== 0) {
          row.T = 2;
          this.tableDel.push(row);
        }
        if (this.saveData.length == 1) {
          this.saveData.splice(index, 1);
        } else {
          this.saveData.splice(index, 1);
        }
      });
    },
    add() {
      let o = {};
      o.T = 0;
      this.column.forEach((v) => {
        o[v] = "";
      });
      this.saveData.push(o);
    },
    // 父组件调用
    getTable() {
      return this.saveData.concat(this.tableDel);
    },
    //父组件调用
    clearDel(){
      this.tableDel = [];
    }
  },
};
</script>
